import { IDate, IPosition, IPunchShortDocument, IUIUser } from "../models"
import AccountStore from "../stores/AccountStore"
import moment from "moment"
import * as timeHelper from "./timeHelper"
import strings from "../localization/strings"
import * as payGroupAndTypeHelper from "./payGroupAndTypeHelper"

export function getPositionFromId(id, masterPositionList) {
    if (masterPositionList) {
        for (let i = 0; i < masterPositionList.length; i++) {
            if (masterPositionList[i] && masterPositionList[i].Id === id) {
                return masterPositionList[i]
            }
        }
    }

    return null
}

export function getPositionFromBasePositionId(basePositionId, masterPositionList) {

    if (masterPositionList) {
        for (let i = 0; i < masterPositionList.length; i++) {
            if (masterPositionList[i] && masterPositionList[i].BasePositionId === basePositionId) {
                return masterPositionList[i]
            }
        }
    }

    return null
}

export function getPositionColorFromBasePositionId(basePositionId) {
    const position = getPositionFromBasePositionId(basePositionId, AccountStore.CurrentAccount.PositionDefinitions) as IPosition

    if (!position) {
        return null
    }

    return position.Color
}

export function checkPositionDateForGlobalEditPunches(position: IPosition, commonGlobalPunchData: IPunchShortDocument, globalPunchEmployees: IUIUser[]): boolean {
    if (commonGlobalPunchData && commonGlobalPunchData.PunchDateData && commonGlobalPunchData.PunchDateData.length > 0) {
        const result = commonGlobalPunchData.PunchDateData.map(i => {
            const employee = globalPunchEmployees.find(e => e.Id === i.UserId)
            const payGroupId = payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData(employee)
            return checkPositionDate(position, i.DateTimeLocal, payGroupId)
        })
        var indexOf = result.indexOf(false)
        return indexOf < 0
    }
    else {
        return true
    }
}

export function checkPositionDateForGlobalAddPunches(position: IPosition, day: IDate, globalPunchEmployees: IUIUser[]): boolean {
    const result = globalPunchEmployees.map(employee => {
        const payGroupId = payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData(employee)
        return checkPositionDate(position, day, payGroupId)
    })
    var indexOf = result.indexOf(false)
    return indexOf < 0
}

export function checkPositionDate(position: IPosition, day: IDate, payGroupId: string): boolean {
    if (!position || !day)
        return true
    const payGroup = AccountStore.getCurrentAccount().PayGroups.find(i => i.Id == payGroupId)
    const dayStartTime = payGroup ? payGroup.PaySettings.PayPeriodDayStartTime24Hour : 0
    const positionStartDate = position.StartDate && timeHelper.convertDefaultDateToNull(position.StartDate) ?
        timeHelper.keepConvertUTCToLocal(position.StartDate) :
        null
    const positionEndDate = position.EndDate && timeHelper.convertDefaultDateToNull(position.EndDate) ?
        timeHelper.keepConvertUTCToLocal(position.EndDate) :
        null
    const positionStartDateTime = positionStartDate ? moment(positionStartDate).startOf("day").add(dayStartTime, "hour") : null
    const positionEndDateTime = positionEndDate ? moment(positionEndDate).endOf("day").add(dayStartTime, "hour") : null
    if (positionStartDateTime && moment(day).isBefore(positionStartDateTime))
        return false
    if (positionEndDateTime && moment(day).isAfter(positionEndDateTime))
        return false
    return true
}

export function getPositionDateErrorStr(position: IPosition): string {
    let errorStr = strings.No_match_position_date
    const startDate = position.StartDate ? timeHelper.convertDefaultDateToNull(position.StartDate) : null
    const endDate = position.EndDate ? timeHelper.convertDefaultDateToNull(position.EndDate) : null
    if (startDate && endDate) {
        errorStr = `${errorStr} (${moment(timeHelper.keepConvertUTCToLocal(startDate)).format("MM/DD/YY")} - ${moment(timeHelper.keepConvertUTCToLocal(endDate)).format("MM/DD/YY")})`
    }
    else if (startDate) {
        errorStr = `${errorStr} (${strings.Start_Date}: ${moment(timeHelper.keepConvertUTCToLocal(startDate)).format("MM/DD/YY")})`
    }
    else if (endDate) {
        errorStr = `${errorStr} (${strings.End_Date}: ${moment(timeHelper.keepConvertUTCToLocal(endDate)).format("MM/DD/YY")})`
    }
    return errorStr
}

export function checkPositionFieldAvailable(position: "singular" | "plural") {
    if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels) {
        if (position === "plural") {
            if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel) {
                return true
            }
        } else if (position === "singular") {
            if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel) {
                return true
            }
            return false
        }

        return false
    }
    return false
}
